import * as React from 'react';
import Tag from 'antd/lib/tag';
import { antGrey, runwayColors, tagStyle } from '../styles/globalStyles';

interface RolloutBadgeProps {
    isRolloutPaused: boolean;
    isPausedByRunway?: boolean;
}

export const RolloutBadge: React.FC<RolloutBadgeProps> = ({ isRolloutPaused, isPausedByRunway }) => {
    if (!isRolloutPaused) {
        return null;
    }

    const pausedColor = isPausedByRunway ? runwayColors.statusRed : runwayColors.statusYellow;
    const rolloutBadge =
        isRolloutPaused ? { text: 'Paused', color: pausedColor } : { text: 'Active', color: runwayColors.primary };

    return (
        <Tag
            style={{
                ...tagStyle,
                color: rolloutBadge.color,
                borderColor: rolloutBadge.color,
                backgroundColor: antGrey.grey2,
                marginInlineEnd: 0,
            }}
        >
            {rolloutBadge.text}
        </Tag>
    );
};
